import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export default {
  container: (editorHeight) => ({
    width: '100%',
    padding: '1px',
    transition: editorHeight > 122 ? '' : 'height 0.1s',
    overflow: 'hidden',
    backgroundColor: colors.white,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  }),
  editor: (isReply) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    paddingTop: '11px',
    paddingRight: `${isReply ? '14px' : '13px'}`,
    paddingBottom: '11px',
    border: `1px solid ${colors.grey3}`,
  }),
  commentButton: {
    fontSize: 14,
    color: 'green',
    backgroundColor: colors.white,
    border: `1px solid ${colors.grayDark}`,
    borderRadius: 2,
    padding: '6px 10px',
    marginTop: -6,
    cursor: 'pointer',

    ':hover': {
      color: 'red',
    },
  },
  avatar: {
    marginRight: '13px',
  },
};
